import { HeadingPages } from '../../../components/HeadingPages'
import { Box, Button, Flex, Grid, Text } from '@chakra-ui/react'

import InputFloating from '../../../components/InputFloating'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormControl, FormErrorMessage } from '@chakra-ui/form-control'
import React, { useEffect, useRef, useState } from 'react'
import { Modal } from './components/Modal'
import { ViewImage } from './components/ViewImage'
import { api } from '../../../services/api'
const schema = yup.object().shape({
  pedido: yup.string().required('Campo obrigatório'),
})
export function UploadCanhoto() {
  const { register, handleSubmit, formState, watch } = useForm({
    resolver: yupResolver(schema),
  })
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  const watchFields = watch(['pedido'])

  const [image, setImage] = useState(null)

  const { errors } = formState

  console.log(errors)

  async function onSubmit(data) {}

  async function getDadosCanhoto() {
    setLoading(true)
    const response = await api.get(
      `/site/v2/organiza-canhoto/lista-informacoes-canhoto/${watchFields[0]}`
    )

    setData(response.data)

    console.log('response', response)

    setLoading(false)
  }

  console.log(data)

  return (
    <>
      <HeadingPages name="Upload Canhoto" />
      <Box maxW={'1200px'} w={'full'} mx={'auto'}>
        <Flex
          gap={2}
          mt={'1rem'}
          maxW={'500px'}
          w={'full'}
          mx={'auto'}
          as="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <FormControl isInvalid={errors?.pedido}>
            <InputFloating label={'Nº Pedido'} {...register('pedido')} />
            {errors?.pedido && (
              <FormErrorMessage>
                <span role="img" aria-label="so sad">
                  😭
                </span>{' '}
                {errors?.pedido?.message}
              </FormErrorMessage>
            )}
          </FormControl>
          <Modal
            image={image}
            formState={formState}
            errors={errors}
            watchFields={watchFields}
            getDadosCanhoto={getDadosCanhoto}
          />
          <Button
            colorScheme="blue"
            size="md"
            isLoading={formState.isSubmitting}
            onClick={getDadosCanhoto}
          >
            Buscar
          </Button>
        </Flex>

        <Grid mt={'1rem'} templateColumns="repeat(3, 1fr)" gap={6}>
          {data?.map((item, index) => (
            <Flex
              gap={2}
              alignItems={'flex-start'}
              justifyContent={'flex-start'}
              mt={'2rem'}
              maxW={'500px'}
              w={'full'}
              mx={'auto'}
            >
              <ViewImage image={item.link_imagem} />
              <Flex flexDir={'column'}>
                <Text
                  fontSize={'1.2rem'}
                  fontWeight={'500'}
                  color={'gray.600'}
                  mb={2}
                >
                  Nº Pedido: {item.numero_pedido}
                </Text>
              </Flex>
            </Flex>
          ))}
        </Grid>
      </Box>
    </>
  )
}
